import React from "react";
import { Icon } from "antd";
import PropTypes from "prop-types";

const EmptyState = ({ icon, message }) => {
  return (
    <div className="empty-state">
      <h5 className="no-data-note">
        <Icon type={icon} style={{ marginRight: '8px' }} />
        {message}
      </h5>
    </div>
  );
};

EmptyState.propTypes = {
  icon: PropTypes.string,
  message: PropTypes.string
};

EmptyState.defaultProps = {
  icon: "info-circle",
  message: "No data available"
};

export default EmptyState;
